import React from 'react'
import { Outlet, Link } from "react-router-dom";

import '../css/flota.css'

import reloj from '../assets/images/flota/reloj_reloj-g.svg'
import users_usuarios from '../assets/images/flota/users_usuarios-g.svg'
import ferry from '../assets/images/flota/ferry_ferry icon-g.svg'
import reservacion from '../assets/images/cta/reservacion.svg'

import california_star from '../assets/images/flota/california-star.webp'
import mexico_star from '../assets/images/flota/mexicoStar01.webp'
import cabo_star from '../assets/images/flota/cabostar.webp'
import mapa from '../assets/images/pregutas.png'
import { useTranslation } from 'react-i18next';
import Footer from '../components/Footer'

export default function Flota() {

    const { t } = useTranslation('flota');
    // Define las listas de imágenes para desierto y playa


  return (
    <> 
    <section>
        <div className='header_section'>
            <div className='container header_section_box'>
                <div className='header_section_title'>
                    <h3>{t('flota')}</h3>
                    <p>{t('flota_p')}</p>
                </div>                
            </div>
        </div>
    </section>
    <section className='flota'>
        <div className='container'>
            <div className='content_fota'>
                <div className='content_img_fota'>
                    <img src={california_star} alt='california star'/>
                </div>
                <div>
                    <p className='title_buque_flota'>{t('title_buque_flota')}</p>
                    <p className='name_buque_flota'>California Star</p>
                    <p className='routes_buque_flota'>{t('routes_buque_flota1')}: Topolobampo <i class="fi fi-rr-exchange-alt"></i> La Paz</p>
                </div>
                <div className='content_info_fota'>
                    <p><i><img src={reloj} alt='flota california star' /></i>21 {t('content_info_fota_p1')} (38.89km)</p>
                    <p><i><img src={users_usuarios} alt='flota california star' /></i>400 {t('content_info_fota_p2')}</p>
                    <p><i><img src={ferry} alt='flota california star' /></i>3,000 {t('content_info_fota_p3')}</p>
                    <p><i class="fi fi-ts-ruler-horizontal"></i>193 {t('content_info_fota_p4')}</p>
                    <p><i class="fi fi-ts-ruler-vertical"></i>25.5 {t('content_info_fota_p5')}</p>
                </div>
                <div className='btns_flota'>
                    <Link to="/rutas_horario" className='flota_reserva'>{t('flota_reserva')}</Link>                
                    <Link to="/servicios-california-star" className='flota_ver_mas'> {t('flota_ver_mas')}</Link>  
                </div>
            </div>
            <div className='content_fota'>
                <div className='content_img_fota'>
                    <img src={cabo_star} alt='Cabo Star'/>
                </div>
                <div>
                    <p className='title_buque_flota'>{t('title_buque_flota')}</p>
                    <p className='name_buque_flota'>Cabo Star</p>
                    <p className='routes_buque_flota'>{t('routes_buque_flota1')}: Mazatlán <i class="fi fi-rr-exchange-alt"></i> La Paz</p>
                </div>
                <div className='content_info_fota'>
                    <p><i><img src={reloj} alt='flota california star' /></i>22 {t('content_info_fota_p1')}  (40.74km)</p>
                    <p><i><img src={users_usuarios} alt='flota california star' /></i>400 {t('content_info_fota_p2')}</p>
                    <p><i><img src={ferry} alt='flota california star' /></i>3,000 {t('content_info_fota_p3')}</p>
                    <p><i class="fi fi-ts-ruler-horizontal"></i>193 {t('content_info_fota_p4')}</p>
                    <p><i class="fi fi-ts-ruler-vertical"></i>25.5 {t('content_info_fota_p5')}</p>
                </div>
                <div className='btns_flota'>
                    
                    <Link to="/rutas_horario" className='flota_reserva'>{t('flota_reserva')}</Link>    
                    <Link to="/servicios-cabo-star" className='flota_ver_mas'>{t('flota_ver_mas')} </Link>                 
                </div>
            </div>
        </div>
    </section>

    <section className="callToAction">
            <div className='container'>
                <div>
                    <h3> </h3>
                </div>
                <div className='callToAction_row'>
                    
                    <div className='callToAction_container'>
                        <div className='callToAction_icon'>
                            <img src={mapa} alt="bookingIcon" className='bookingIcon' />
                        </div>
                        <div className='callToAction_content'>
                            <div className='callToAction_box'>
                                <div>
                                    <h4>{t('cta1_title1')}</h4>
                                </div>
                                <div>
                                    <p>{t('cta_title1')}</p>
                                </div>
                            </div>
                            <div className='callToAction_box'>
                                <Link to="/certificaciones">{t('cta_btn1')} </Link>     
                            </div>
                        </div>
                    </div>
                    <div className='callToAction_container'>
                        <div className='callToAction_icon'>
                            <img src={reservacion} alt="bookingIcon" className='bookingIcon' />
                        </div>
                        <div className='callToAction_content'>
                            <div className='callToAction_box'>
                                <div>
                                    <h4>{t('cta1_title2')}</h4>
                                </div>
                                <div>
                                    <p>{t('cta_title2')}</p>
                                </div>
                            </div>
                            <div className='callToAction_box'>
                            <a href="https://wa.me/5218003377437?text=Me%20interesa%20una%20cotizaci%C3%B3n" target="_blank" rel="noopener noreferrer">{t('cta_btn2')}</a>                    
                            </div>
                        </div>
                    </div>
                     <div className='callToAction_container'>
                    <div className='callToAction_icon'>
                        <img src={reservacion} alt="bookingIcon" className='bookingIcon' />
                    </div>
                    <div className='callToAction_content'>
                        <div className='callToAction_box'>
                            <div>
                                <h4>{t('cta1_title3')}</h4>
                            </div>
                            <div>
                                <p>{t('cta_title3')} </p>
                            </div>
                        </div>
                        <div className='callToAction_box'>
                        <a href="tel:8003377437" target="_blank" rel="noopener noreferrer">{t('cta_btn3')} </a>                        
                        </div>
                    </div>
                </div>
                </div>
            </div>
    </section>
    <Outlet />
    <Footer />
    
</>
  )
}

